import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import store from '../store';
import SocketIO from 'socket.io-client';

Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV !== 'production',
    connection: SocketIO('', {
      cookie: true,
    }),
    vuex: {
      store,
      actionPrefix: 'socket_',
      mutationPrefix: 'socket_',
    },
  }),
);
